import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-expertise',
  templateUrl: './expertise.component.html',
  styleUrls: ['./expertise.component.scss'],
  imports: [TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpertiseComponent {
  public readonly expertises = [
    {
      name: 'main_page.expertise.implementations',
      number: '1400+',
      image: 'activity.svg',
    },
    {
      name: 'main_page.expertise.sessions',
      number: '250M',
      image: 'clipboard.svg',
    },
    {
      name: 'main_page.expertise.countries',
      number: '20+',
      image: 'globe.svg',
    },
    {
      name: 'main_page.expertise.languages',
      number: '10+',
      image: 'flag.svg',
    },
    {
      name: 'main_page.expertise.partners',
      number: '10+',
      image: 'anchor.svg',
    },
  ];
}
